export const LEVELS = [
  {text: '1ESO', value: 1},
  {text: '2ESO', value: 2},
  {text: '3ESO', value: 3},
  {text: '4ESO', value: 4},
  {text: '1BATX', value: 5},
  {text: '2BATX', value: 6}
]

export const GROUPS = [
  {text: 'A', value: 1},
  {text: 'B', value: 2},
  {text: 'C', value: 3},
  {text: 'D', value: 4},
  {text: 'E', value: 5},
  {text: 'F', value: 6}
]



// WEBPACK FOOTER //
// ./src/api/utils.js